// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_alignRight_wgjy6ne2FOTFOBWThHKv {
  text-align: right !important;
}

.style-module_alignCentre_Ht5vrNJF2GH9xuYHhI4w {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/style.module.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;;AAEA;EACE,6BAAA;AACF","sourcesContent":[".alignRight {\n  text-align: right !important;\n}\n\n.alignCentre {\n  text-align: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alignRight": `style-module_alignRight_wgjy6ne2FOTFOBWThHKv`,
	"alignCentre": `style-module_alignCentre_Ht5vrNJF2GH9xuYHhI4w`
};
export default ___CSS_LOADER_EXPORT___;
